const faRectangleHistory = {
  prefix: 'fal',
  iconName: 'rectangle-history',
  icon: [
    512,
    512,
    [],
    'e4a2',
    'M480 272c0-17.7-14.3-32-32-32L64 240c-17.7 0-32 14.3-32 32l0 144c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-144zm-32-64c35.3 0 64 28.7 64 64l0 144c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 272c0-35.3 28.7-64 64-64l384 0zm0-104c8.8 0 16 7.2 16 16s-7.2 16-16 16L64 136c-8.8 0-16-7.2-16-16s7.2-16 16-16l384 0zM400 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L112 32c-8.8 0-16-7.2-16-16s7.2-16 16-16L400 0z',
  ],
};
export default faRectangleHistory;
